module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAYklEQVQ4T2NkoBAwUqifgbYGzJgxYwcDA8P/jIwMT1wuxeuCGTNmfGNkZPyfnp7OPUQMmDlz5hkGBgZjfDHz////MxkZGaYwNShhQLEB6DYPwUDE4gXKEhIx+YS2eYEYFwAAWM84EQB6kpYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/playList/img/songListAdd.png
// module id = DDPa
// module chunks = 11